module.exports = __webpack_public_path__ + "static/media/hall-P8.2d5e81e4.svg";